import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyPortals = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 17.5h5a2.5 2.5 0 0 0 2.5-2.5V5A2.5 2.5 0 0 0 15 2.5H5A2.5 2.5 0 0 0 2.5 5v5M2.5 7.5h15",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.167 4.996 9.162 5l.005.004L9.17 5l-.004-.004M7.08 4.996 7.078 5l.004.004L7.085 5l-.004-.004M5.003 4.996 4.998 5l.005.004L5.007 5l-.004-.004M2.5 13.333A4.167 4.167 0 0 1 6.667 17.5M2.5 15.833c.92 0 1.667.746 1.667 1.667",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMyPortals;
